import { render, staticRenderFns } from "./LoadAndBillOfLoad.vue?vue&type=template&id=fbacd240"
import script from "./LoadAndBillOfLoad.vue?vue&type=script&lang=js"
export * from "./LoadAndBillOfLoad.vue?vue&type=script&lang=js"
import style0 from "./LoadAndBillOfLoad.vue?vue&type=style&index=0&id=fbacd240&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports